import axiosInstance from '../api';

interface BuyerClosingCostsParams {
  offerId?: string;
  propertyPrice?: number;
  propertyTax?: number;
  // 'Finance' is the legacy stored value still set as the default on
  // the backend; 'Financed' / 'Cash' / 'VA' are what the offer form
  // sends. All four pass through `.toUpperCase()` matching in
  // calculateBuyerBrokerFee (only VA / CASH branch).
  paymentMethod?: 'Finance' | 'Financed' | 'Cash' | 'VA';
  downPaymentPercent?: number;
  isAssumable?: boolean;
  hasInspection?: boolean;
  hasHomeSaleContingency?: boolean;
  token?: string;
}

const buyerClosingCostsService = {
  find: async (params: BuyerClosingCostsParams) => {
    const res = await axiosInstance.get('/buyer-closing-costs', {
      params,
    });
    return res.data;
  },
};

export default buyerClosingCostsService;